import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HomeService } from '../home-service/home.service';

@Component({
  selector: 'app-bloco-status-rede',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './bloco-status-rede.component.html',
  styleUrls: ['./bloco-status-rede.component.scss'],
})
export class BlocoStatusRedeComponent implements OnInit {
  loading              = true;
  atualizacoesRelevantes: any[] = [];
  obrasSemInteracao    = 0;
  tarefasAtrasadas     = 0;

  constructor(private readonly homeService: HomeService) {}

  ngOnInit(): void {
    this.homeService.getNetworkStatus(7, 10).subscribe({
      next: (res) => {
        const d = res?.data;
        this.atualizacoesRelevantes = (d?.atualizacoesRelevantes ?? []).map((item: any) => ({
          total: item.totalNovasObras,
          descricao: item.moduleName,
        }));
        this.obrasSemInteracao      = d?.pontosDeAtencao?.obrasSemInteracao      ?? 0;
        this.tarefasAtrasadas       = d?.pontosDeAtencao?.tarefasAtrasadas       ?? 0;
        this.loading                = false;
      },
      error: () => { this.loading = false; },
    });
  }
}